import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dependents-explained',
  templateUrl: './dependents-explained.component.html',
  styleUrls: ['./dependents-explained.component.scss']
})
export class DependentsExplainedComponent implements OnInit {

  dependentsCutOffAge: any;
  dependents: any;
  yearDifference: any;

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<DependentsExplainedComponent>) { 
    this.dependentsCutOffAge = data.dependentsCutOffAge;    
    this.yearDifference = data.yearDifference;
    this.dependents = data.dependents.filter((chids) => ((this.yearDifference + chids.age) <= this.dependentsCutOffAge));
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
